<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="订单号" class="EL-Form-Item">
            <el-input
              v-model="pagination.orderCode"
              placeholder="请输入"
              @change="saveSearch()"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料号" class="EL-Form-Item">
            <el-input
              v-model="pagination.matCode"
              placeholder="请输入"
              @change="saveSearch()"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="批次" class="EL-Form-Item">
            <el-input
              v-model="pagination.batchNo"
              placeholder="请输入"
              @change="saveSearch()"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
					<el-form-item label="供应商" class="EL-Form-Item">
						<el-select v-model="pagination.verdorCode" placeholder="请选择" filterable clearable="clearable">
              <el-option v-for="(item, index) in vendorList" :key="index" :label="item.svCode + ' - ' + item.vendorName" :value="item.svCode">
              </el-option>
            </el-select>
					</el-form-item>
				</el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker
              v-model="pagination.updateTime[0]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker
              v-model="pagination.updateTime[1]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getMainData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="质量报表">
        <el-button v-authority="'BACK_MENU2_M6_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <!-- 展示 -->
      <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getMainData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
        <el-table-column label="物料号" prop="matCode" align="center"></el-table-column>
        <el-table-column label="供应商" prop="verdorCode" align="center"></el-table-column>
        <el-table-column label="公差" prop="matSpecs" align="center"></el-table-column>
        <el-table-column label="批次" prop="batchNo" align="center"></el-table-column>
        <el-table-column label="合计数量" prop="totalQuantity" align="center"></el-table-column>
        <el-table-column label="合格数量" prop="qualifiedQuantity" align="center"></el-table-column>
        <el-table-column label="不合格数量" prop="unqualifiedQuantity" align="center"></el-table-column>
        <el-table-column label="报废数量" prop="scrapQuantity" align="center"></el-table-column>
      </h-table>
    </box>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "QualityReport",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        fcCode: localStorage.getItem("fcCode") || "",
        orderCode: "",
        matCode: "",
        batchNo: "",
        verdorCode: "",
        updateTime: [],
      },
      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      vendorList: [], // 供应商列表
    };
  },
  watch: {
    pagination: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getMainData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.updateTime[0]) {
            return time.getTime() < new Date(_this.pagination.updateTime[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.updateTime[1]) {
            return time.getTime() > new Date(_this.pagination.updateTime[1]);
          }
        },
      };
    },
  },
  methods: {
    // 时间转换
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getMainData();
      }, 1000);
    },
    //获取数据
    getMainData() {
      if (this.pagination.updateTime.length != 2) {
        this.$message({
          message: "筛选条件的开始时间、结束时间不能为空",
          type: "warning",
        });
				return;
      }

      this.$http
        .request({
          url: "/api/order/getQualityReport",
          method: "GET",
          params: {
            pageNum: this.pagination.pageNum || null,
            pageSize: this.pagination.pageSize || null,
            fcCode: this.pagination.fcCode || null,
            orderCode: this.pagination.orderCode || null,
            matCode: this.pagination.matCode || null,
            batchNo: this.pagination.batchNo || null,
            verdorCode: this.pagination.verdorCode || null,
            beginTime: this.pagination.updateTime[0] || null,
            endTime: this.pagination.updateTime[1] || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    //重置
    resetData() {
      (this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        fcCode: "",
        batchNo: "",
        verdorCode: "",
        updateTime: [],
      }),
        this.getMainData();
    },

    //表格导出
    downLoadFile() {
      if (this.pagination.updateTime.length != 2) {
        this.$message({
          message: "筛选条件的开始时间、结束时间不能为空",
          type: "warning",
        });
				return;
      }
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.pagination.fcCode || null,
        orderCode: this.pagination.orderCode || null,
        matCode: this.pagination.matCode || null,
        batchNo: this.pagination.batchNo || null,
        verdorCode: this.pagination.verdorCode || null,
        beginTime: this.pagination.updateTime[0] || null,
        endTime: this.pagination.updateTime[1] || null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/order/getQualityReport",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function (c) {});
        const tHeader = [
          "物料号",
          "供应商",
          "公差",
          "批次",
          "合计数量",
          "合格数量",
          "不合格数量",
          "报废数量",
        ];
        const filterVal = [
          "matCode",
          "verdorCode",
          "matSpecs",
          "batchNo",
          "totalQuantity",
          "qualifiedQuantity",
          "unqualifiedQuantity",
          "scrapQuantity",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "质量报表",
        });
        this.logContent = "导出";
        this.logRemarks = "QualityReport：导出质量报表数据";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "质量报表",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
    async getVerdorList() {
			try {
				const res = await this.$http.request({
					url: "/api/vendor/getVendorAll",
					method: "GET",
					showLoading: true,
					params: {
						pageNum: 1,
						pageSize: 999999,
					},
				})
				if (res.status == 100) {
					this.vendorList = res.data.list
				} else {
					this.vendorList = []
				}
			} catch (error) {
				this.vendorList = []
			}
		},
  },
  activated() {
    /* 获取页面主数据 */
    this.getMainData();
    this.getVerdorList()
  },
};
</script>

<style scoped>
</style>